import errorLogger from '@picsart/growth-rc/services/errorLogger';
import { ILanguages } from '@picsart/rc/types/data/languages';
import { ReactNode } from 'react';
import INTLProvider from './INTLProvider';

export type GlobalProvidersProps = {
  children: ReactNode | ReactNode[];
  isLocalized: boolean;
  slug: string;
  dropdownLanguagesList: ILanguages;
  translatedData?: Record<string, string>;
  dataFetched: boolean;
};
const ErrorBoundary = errorLogger.getErrorBoundary();

export default function GlobalProviders({
  isLocalized,
  slug,
  dropdownLanguagesList,
  children,
  translatedData,
  dataFetched,
}: GlobalProvidersProps) {
  return (
    <ErrorBoundary>
      {dataFetched ? (
        <INTLProvider
          slug={slug}
          isLocalized={isLocalized}
          languagesList={dropdownLanguagesList}
          translatedData={translatedData}
        >
          {children}
        </INTLProvider>
      ) : (
        <>{children}</>
      )}
    </ErrorBoundary>
  );
}
